import { defineMessages } from 'react-intl';

export const cashCollectionsMessages = defineMessages({
    cashCollections: {
        id: 'cash-collections',
        defaultMessage: 'Cash collections',
    },
    cashCollection: {
        id: 'cash-collection',
        defaultMessage: 'Cash collection',
    },
    allCashCollections: {
        id: 'all-cash-collections',
        defaultMessage: 'All cash collections',
    },
    cashCollectionsDescription: {
        id: 'cash-collections-description',
        defaultMessage: 'Review all operations for cash collections from pay stations',
    },
    cashCollectionsReport: {
        id: 'cash-collections-report',
        defaultMessage: 'Report for all cash collections',
    },
    cashCollectionNumber: {
        id: 'cash-collection-number',
        defaultMessage: 'Number',
    },
    cashCollectionStatus: {
        id: 'cash-collection-status',
        defaultMessage: 'Status',
    },
    cashCollectionTotalAmount: {
        id: 'cash-collection-total-amount',
        defaultMessage: 'Total amount',
    },
    cashCollectionCollectedBy: {
        id: 'cash-collection-collected-by',
        defaultMessage: 'Collected by',
    },
    cashCollectionDate: {
        id: 'cash-collection-date',
        defaultMessage: 'Date',
    },
    collections: {
        id: 'collections',
        defaultMessage: 'Collections',
    },
    collection: {
        id: 'collection',
        defaultMessage: 'Collection',
    },
    cashCollectionsPayStation: {
        id: 'cash-collections-pay-station',
        defaultMessage: 'Pay station',
    },
    cashCollectionsPaid: {
        id: 'cash-collections-paid',
        defaultMessage: 'Paid',
    },
    cashCollectionsCollected: {
        id: 'cash-collections-collected',
        defaultMessage: 'Collected',
    },
    newCashCollectionDescription: {
        id: 'new-cash-collection-description',
        defaultMessage: 'Populate the cash amounts that are collected',
    },
    collectionDetails: {
        id: 'collection-details',
        defaultMessage: 'Collection details',
    },
    collectorName: {
        id: 'collector-name',
        defaultMessage: 'Collector name',
    },
    collectionDescription: {
        id: 'collection-description',
        defaultMessage: 'Description',
    },
    createNewCashCollection: {
        id: 'create-new-cash-collection',
        defaultMessage: 'Create new cash collection',
    },
    cashCollectionsCreated: {
        id: 'cash-collections-created',
        defaultMessage: 'Cash collection created',
    },
    cashBreakdown: {
        id: 'cash-breakdown',
        defaultMessage: 'Cash breakdown',
    },
    cashCollectionConfigurationError: {
        id: 'cash-collection-configuration-error',
        defaultMessage: 'The parking is not configured to support cash collection.',
    },
    cashCollectionCreatedDescription: {
        id: 'cash-collection-created-description',
        defaultMessage: 'The cash collection was created successfully.',
    },
    cashCollectionCoins: {
        id: 'cash-collection-coins',
        defaultMessage: 'Coins',
    },
    cashCollectionBanknotes: {
        id: 'cash-collection-banknotes',
        defaultMessage: 'Banknotes',
    },
    cashCollectionDelete: {
        id: 'cash-collection-delete',
        defaultMessage: 'Delete cash collection',
    },
    cashCollectionDeleteConfirmation: {
        id: 'cash-collection-delete-confirmation',
        defaultMessage: 'Are you sure you want to delete this cash collection?',
    },
    cashCollectionDeleted: {
        id: 'cash-collection-deleted',
        defaultMessage: 'Cash collection deleted',
    },
    cashCollectionDeletedSuccessfully: {
        id: 'cash-collection-deleted-successfully',
        defaultMessage: 'The cash collection was deleted successfully.',
    },
    cashCollectionDateTime: {
        id: 'cash-collection-date-time',
        defaultMessage: 'Date and time',
    },
    evidence: {
        id: 'evidence',
        defaultMessage: 'Evidence',
    },
    editCashCollection: {
        id: 'edit-cash-collection',
        defaultMessage: 'Edit cash collection',
    },
    cashCollectionUpdated: {
        id: 'cash-collection-updated',
        defaultMessage: 'Updated successfully',
    },
    cashCollectionUpdatedSuccessfully: {
        id: 'cash-collection-updated-successfully',
        defaultMessage: 'The cash collection was updated successfully.',
    },
    editCashCollectionDescription: {
        id: 'edit-cash-collection-description',
        defaultMessage: 'Edit the cash amounts that are collected',
    },
    createdBy: {
        id: 'created-by',
        defaultMessage: 'Created by',
    },
    description: {
        id: 'description',
        defaultMessage: 'Description',
    },
    reference: {
        id: 'reference',
        defaultMessage: 'Reference',
    },
    totalCashCollected: {
        id: 'total-cash-collected',
        defaultMessage: 'Total cash collected',
    },
    totalCoinsCollected: {
        id: 'total-coins-collected',
        defaultMessage: 'Total coins collected',
    },
    totalBanknotesCollected: {
        id: 'total-banknotes-collected',
        defaultMessage: 'Total banknotes collected',
    },
    totalCollectionsNumber: {
        id: 'total-collections-number',
        defaultMessage: 'Total number of collections',
    },
    cashCollectionStatusChange: {
        id: 'cash-collection-status-change',
        defaultMessage: 'Change the status of the selected cash collections',
    },
    cashCollectionStatusUpdatedSuccessfully: {
        id: 'cash-collection-status-updated-successfully',
        defaultMessage: 'The status was updated successfully for the selected cash collections.',
    },
    changeStatus: {
        id: 'change-status',
        defaultMessage: 'Change status',
    },
    multipleCashCollections: {
        id: 'multiple-cash-collections',
        defaultMessage: 'Collections',
    },
    cashCollectionType: {
        id: 'cash-collection-type',
        defaultMessage: 'Type',
    },
    cashCollectionCollect: {
        id: 'cash-collection-collect',
        defaultMessage: 'Collect',
    },
    cashCollectionLoad: {
        id: 'cash-collection-load',
        defaultMessage: 'Load',
    },
    cashCollectionLoaded: {
        id: 'cash-collection-loaded',
        defaultMessage: 'Loaded',
    },

    totalCashLoaded: {
        id: 'total-cash-loaded',
        defaultMessage: 'Total cash loaded',
    },
    totalCoinsLoaded: {
        id: 'total-coins-loaded',
        defaultMessage: 'Total coins loaded',
    },
    totalBanknotesLoaded: {
        id: 'total-banknotes-loaded',
        defaultMessage: 'Total banknotes loaded',
    },
    totalLoadNumber: {
        id: 'total-load-number',
        defaultMessage: 'Total number of loads',
    },
});
